<template>
  <div>
    <el-upload
      @mouseenter.native="showShade = true"
      @mouseleave.native="showShade = false"
      v-loading="loading"
      class="avatar-uploader"
      :action="uploadUrl"
      :data="uploadData"
      :headers="header"
      list-type="picture"
      :show-file-list="false"
      :on-success="handleSuccess"
      :on-error="handleError"
      :before-upload="beforeUpload"
      id="noPersonStepThirdBusiness"
    >
      <img v-if="upload.imgUrl" :src="upload.imgUrl" class="avatar" />

      <i v-else class="jc-icon-plus avatar-uploader-icon"></i>

      <div class="upload-back" v-show="showShade && upload.imgUrl">
        <div class="preview" @click.stop="dialogVisible = true">
          <i class="jc-icon-view" @click.stop="dialogVisible = true"></i>
        </div>

        <div class="delete">
          <i class="jc-icon-delete2" @click.stop="deleteImg"></i>
        </div>
      </div>
    </el-upload>

    <!--图片放大预览弹窗-->
    <el-dialog v-model="dialogVisible" width="50%" title="预览" append-to-body>
      <img :src="upload.imgUrl" style="width: 100%" />
    </el-dialog>
  </div>
</template>

<script>
import outMsg from '@/mixins/message-mixins.js'
import Cookie from 'js-cookie'
export default {
  name: 'sk-upload',
  props: {
    value: {
      type: Object,
      require: true,
    },
    uploadData: Object,
    limit: Number,
  },
  components: {},
  mixins: [outMsg],
  data() {
    return {
      upload: {
        imgUrl: '',
      },
      uploadUrl:
        '/upload/v1/regions/cn-north-1/distributorManage:uploadBusinessLicenseFile',
      showShade: false,
      dialogVisible: false,
      loading: false,
    }
  },
  watch: {
    value(val) {
      this.upload = val
    },
    upload: {
      deep: true,
      handler(val) {
        this.$emit('input', val)
      },
    },
  },
  computed: {
    header() {
      return {
        'x-csrf-token': Cookie.get('csrfToken'),
      }
    },
  },
  mounted() {},
  created() {
    this.upload = this.value
  },
  filters: {},
  methods: {
    beforeUpload(file) {
      const isJPG =
        file.type === 'image/jpeg' ||
        file.type === 'image/jpg' ||
        file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.outMsg('error', '上传图片只能是 JPG、JPEG或PNG 格式！')
      }
      if (!isLt2M) {
        this.outMsg('error', '上传图片大小不能超过 2MB！')
      }
      if (isJPG && isLt2M) {
        this.loading = true
      } else {
        return false
      }
    },
    handleSuccess(res) {
      if (res && res.result && res.result.uri) {
        let url = res.result.uri
        this.upload.imgUrl = unescape(url.replace(/\\u/g, '%u'))
        this.upload.businessLicensePic = res.result.businessLicensePic
        this.outMsg('success', '上传成功')
        this.loading = false
        this.$emit('success')
      } else {
        let errorMsg = '上传失败！'
        if (res && res.msg) {
          errorMsg = res.msg
        }
        this.outMsg('error', errorMsg)
        this.loading = false
      }
    },
    handleError() {
      this.loading = false
      this.outMsg('error', '上传失败')
    },
    handlePictureCardPreview() {
      this.dialogVisible = true
    },
    deleteImg() {
      this.upload.imgUrl = ''
      this.upload.businessLicensePic = ''
      this.$emit('success')
    },
  },
}
</script>

<style>
.avatar-uploader {
  height: 94px;
  width: 94px;
  border: 1px dashed #ccc;
  border-radius: 4px;
  position: relative;
}
.jc-upload--picture img {
  width: 100%;
}
.jc-upload--picture {
  height: 94px;
  width: 94px;
  line-height: 94px;
  vertical-align: middle;
  position: relative;
  overflow: hidden;
}
.jc-upload--picture img {
  z-index: 0;
  position: absolute;
  height: 94px;
  width: 94px;
  left: -1px;
  top: -1px;
}
.avatar-uploader-icon {
  background: none;
  height: 92px;
  width: 92px;
  line-height: 92px;
}
.upload-back {
  /* display: block !important; */
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 11;
}
.upload-back > div {
  height: 18px;
  width: 18px;
  display: inline-block;
  margin: 36px 8px 0 8px;
}
.upload-back > div i {
  font-size: 18px;
  display: block;
  color: white;
}
</style>
